import { Menu } from 'lucide-react';
import { useAuth } from '../hooks/useAuth.js';
import { useSidebar } from '../hooks/useSidebar.js';

export function TopBar() {
  const { user } = useAuth();
  const { setMobileOpen } = useSidebar();

  return (
    <header className="flex h-14 items-center border-b border-gray-800 bg-gray-950 px-4">
      {/* Mobile menu button */}
      <button
        onClick={() => setMobileOpen(true)}
        className="rounded-lg p-1.5 text-gray-400 hover:bg-gray-800 hover:text-gray-200 lg:hidden"
      >
        <Menu className="h-5 w-5" />
      </button>

      {/* Brand - mobile only */}
      <div className="ml-3 flex items-center gap-2 lg:hidden">
        <img src="/ologo/ologo-64.png" alt="" className="h-7 w-7" />
        <span className="text-sm font-bold">
          <span className="text-white">Open</span>
          <span className="text-brand-400">Quote Pro</span>
        </span>
      </div>

      <div className="flex-1" />

      {/* Tenant type badge */}
      <span className="rounded-full bg-gray-800 px-3 py-1 text-xs text-gray-400">
        {user?.tenantType === 'reseller' ? 'Reseller' : 'Mfr'}
      </span>

      {/* Plan badge */}
      <span className="ml-2 rounded-full bg-gray-800 px-3 py-1 text-xs text-gray-400">
        {user?.tenant?.plan ?? 'free'}
      </span>

      {/* Tenant name - hidden on small screens */}
      <span className="ml-3 hidden text-sm text-gray-400 sm:block">
        {user?.tenant?.name}
      </span>
    </header>
  );
}
